
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[handle]",
      function () {
        return require("private-next-pages/[handle]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[handle]"])
      });
    }
  